/** @typedef {Object} alkLinkMappingService
 *  @property {Function} getDataVersions
 *  @property {Function} dataVersionSupportsPLIDs
 */

var config = require("config");

(function () {
  "use strict";

  angular
    .module("alk.linkMapping")
    .service("alkLinkMappingService", alkLinkMappingService);

  /** @name alkLinkMappingService
   * @ngdoc service
   * @param {service} $http angularJS [HTTP communication service](https://docs.angularjs.org/api/ng/service/$http)
   * @description Interfaces with the Link Mapping API to translate PLIDs to grid/links, and get PLIDs from grid/links across different data versions.
   * @returns alkLinkMappingService
   * @memberof alk.linkMapping
   */
  function alkLinkMappingService($http) {
    "ngInject";
    var service = {
      getDataVersions: getDataVersions,
      dataVersionSupportsPLIDs: dataVersionSupportsPLIDs
    };

    return service;

    ////////////////

    /** getDataVersions - Returns the list of data versions that are currently supported by the Link Mapping API.
     * @param {Boolean} fullDataVersion - Optional switch to return full data version strings from the API. Default is false.
     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves to an array of string
     * representing the data versions, or rejects to an empty array. The response would look like
     * `["NA-2016-02-12-7", "EU-2016-01-1-5"]`.
     * @memberof alkLinkMappingService
     */
    function getDataVersions(fullDataVersion = false) {
      return $http({
          url: config.linkMappingUrl + "/get-dataversions",
          params: {
            fullVersion: fullDataVersion
          }
        })
        .then((resp) => resp.data, (err) => {
          console.log(err);
          return []
        });
    }

    /** dataVersionSupportsPLIDs - Returns whether or not the supplied data version is part of the Link Mapping API's list of supported data versions.
     * @param {String} dataVersion - The data version to check to see if it supports PLIDs. Default is the empty string.
     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that only resolves to a Boolean.
     * True if the data version supports PLIDs, or false if it doesn't.
     * @memberof alkLinkMappingService
     */
    function dataVersionSupportsPLIDs(dataVersion = "") {
      return getDataVersions()
        .then((dataVersions) => dataVersionHasPLIDs(dataVersion, dataVersions));
    }

    function dataVersionHasPLIDs(dataVersion = "", linkMappingDataVersions = []) {
      if (_.isEmpty(dataVersion) || dataVersion === "Current") {
        return true;
      }

      //  split by .
      var splitDataVersion = dataVersion.split(".");

      //  check length
      if (splitDataVersion.length < 7) {
        return false;
      }

      //  get components
      var components = [
        splitDataVersion[1],
        splitDataVersion[2],
        splitDataVersion[3],
        splitDataVersion[4],
        splitDataVersion[5]
      ];

      var linkMappingDataVersion = components.join("-");
      return _.includes(linkMappingDataVersions, linkMappingDataVersion);
    }
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-link-mapping/alkLinkMapping.service.js